import { render } from "./open-positions-new.vue?vue&type=template&id=a2fb5598&scoped=true"
import script from "./open-positions-new.vue?vue&type=script&lang=js"
export * from "./open-positions-new.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./open-positions-new.vue?vue&type=style&index=1&id=a2fb5598&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2fb5598"]])

export default __exports__